var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SLICE_ALL_WORDS_POSITION = 15;
function OrderedItems(_a) {
    var content = _a.content;
    return (_jsx("ol", __assign({ className: "list-decimal font-light" }, { children: content.map(function (item) { return (_jsx("li", __assign({ className: "ml-4 text-sm" }, { children: item }), "ol-item-" + item.slice(0, SLICE_ALL_WORDS_POSITION))); }) })));
}
function UnorderedItems(_a) {
    var content = _a.content;
    return (_jsx("ul", __assign({ className: "list-disc font-light" }, { children: content.map(function (item, idx) { return (_jsx("li", __assign({ className: "ml-4 text-sm" }, { children: item }), "ul-item-" + item.slice(0, SLICE_ALL_WORDS_POSITION))); }) })));
}
function NoneItems(_a) {
    var content = _a.content;
    return _jsx("p", __assign({ className: "font-light" }, { children: content }));
}
function ListItems(_a) {
    var content = _a.content, listType = _a.listType;
    switch (listType) {
        case "ordered":
            return _jsx(OrderedItems, { content: content });
        case "unordered":
            return _jsx(UnorderedItems, { content: content });
        default:
            return _jsx(NoneItems, { content: content });
    }
}
export function ServiceInfo(_a) {
    var children = _a.children;
    return (_jsx("section", __assign({ className: "w-full max-w-[856px] py-4 px-[30.5px] bg-secondary flex flex-col gap-4 rounded-lg" }, { children: children })));
}
export function ServiceInfoItem(_a) {
    var title = _a.title, content = _a.content, _b = _a.listType, listType = _b === void 0 ? "ordered" : _b;
    return (_jsxs("div", __assign({ className: "text-foreground" }, { children: [_jsx("h6", __assign({ className: "text-lg" }, { children: title })), _jsx(ListItems, { content: content, listType: listType })] })));
}
